import React from 'react';
import styled, {keyframes} from "styled-components";

interface ActionButtonProps {
    color?: string; // Background color
    text?: string; // Button label
    onClick?: () => void;
    bg?: string;
    disabled?: boolean;
    eligible?: boolean;
}

const bounce = keyframes`
    0%, 20%, 50%, 80%, 100% {
        transform: translateY(0);
    }
    40% {
        transform: translateY(-5px);
    }
    60% {
        transform: translateY(5px);
    }
`;

const Pointer2 = styled.div`
    position: absolute;
    left: 80%;
    top: 40%;
    background-size: contain;
    background-repeat: no-repeat;
    animation: ${bounce} 2s infinite;
    z-index: 10000005;
    font-family: monospace;
    width: 30px;
    height: 40px;
`;


const ActionButton: React.FC<ActionButtonProps> = ({
                                                       color = '#00C000',
                                                       bg = '#0A7300',
                                                       text = 'First row',
                                                       onClick,
                                                       disabled,
                                                       eligible = false,
                                                   }) => {
    const disabledStyle = {
        backgroundColor: '#999',
        boxShadow: '0px 6px 0px #666',
        cursor: 'not-allowed',
        opacity: 0.6,
    };

    const enabledStyle = {
        backgroundColor: color,
        boxShadow: `0px 6px 0px ${bg}`,
        cursor: 'pointer',
    };

    return (
        <button
            className={eligible && !disabled ? "pulse" : ""}
            disabled={disabled}
            onClick={onClick}
            style={{
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: '10px',
                padding: '6px 4px',
                display: 'flex',
                alignItems: 'center', ...(!disabled ? enabledStyle : disabledStyle),
            }}
        >
            {eligible && !disabled && (
                <Pointer2>
                    <img
                        draggable={false}
                        src={"./hand-black.png"} style={{
                    }}/>
                </Pointer2>
            )}
            <img
                draggable={false}
                src="./coin-1.png"
                alt="Star Icon"
                style={{
                    width: '16px',
                    height: '16px',
                    marginRight: '2px',
                    opacity: disabled ? 0.5 : 1,
                }}
            />
            <span
                style={{
                    width: "100%",
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: 'white',
                    textAlign: 'center',
                }}
            >
                {text}
            </span>
        </button>
    );
};

export default ActionButton;
